export default "__VITE_PUBLIC_ASSET__136b7b17__"